export default "__VITE_PUBLIC_ASSET__4cd36876__"